import type { Command } from './types';
import { useEditorStore } from '@/store/editorStore';

export const notesCommands: Command[] = [
  {
    id: 'notes.open',
    label: 'Open Notes',
    category: 'edit',
    canExecute: (ctx) => ctx.editorState.selectedNodeIds.length === 1,
    execute: (ctx) => {
      const store = useEditorStore.getState();
      const nodeId = ctx.editorState.selectedNodeIds[0];
      if (!nodeId) return;
      if (store.notesPanelNodeId === nodeId) {
        store.closeNotesPanel();
      } else {
        store.openNotesPanel(nodeId);
      }
    },
  },
  {
    id: 'notes.close',
    label: 'Close Notes',
    category: 'edit',
    canExecute: () => useEditorStore.getState().notesPanelNodeId !== null,
    execute: () => {
      useEditorStore.getState().closeNotesPanel();
    },
  },
];
